import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { UserModel, UserRolesModel, SentInvitationModel, UserBusinessModel } from '@models/index'
import { environment } from '@environments/environment';


@Injectable({
  providedIn: 'root',
})
export class UsersService {
  constructor(
    private http: HttpClient
  ) { }

  searchUsersByBusiness(payload: { page: number; size: number, businessId: string; }): Observable<UserBusinessModel[]> {
    return this.http
      .get<UserBusinessModel[]>(`${environment.apiPath}/userBusiness/business?id=${payload.businessId}&page=${payload.page}&size=${payload.size}`)
  }
  searchUserRoles(): Observable<UserRolesModel[]> {
    return this.http
      .get(`${environment.apiPath}/roles`)
      .pipe(
        map((data: UserRolesModel[]) => data
          .filter((userRole, i, arr) =>
            arr.map(role => role['name'])
              .indexOf(userRole['name']) === i
          ) as UserRolesModel[])
      );

  }

  searchUsersByQuery(searchUserByQuery: string): Observable<UserModel[]> {
    return this.http
      .get(encodeURI(`${environment.apiPath}/users/autocomplete?query=${searchUserByQuery}&page=0&size=10`))
      .pipe(
        map((data: { data: UserModel[], total: number }) => data.data)
      );
  }
  addRoleToUserToBusiness(payload: { user: UserModel, role: UserRolesModel, businessId: string }): Observable<UserBusinessModel> {
    return this.http
      .post<UserBusinessModel>(`${environment.apiPath}/userBusiness`, { userId: payload.user.id, businessId: payload.businessId, roleId: payload.role.id })
  }

  createSentInvitation(sentInvitation: SentInvitationModel): Observable<UserBusinessModel> {
    return this.http
      .post<UserBusinessModel>(
        `${environment.apiPath}/users/invitation`, sentInvitation)

  }
  deleteUser(payload: {userId: string, businessId: string}): Observable<string> {
    return this.http
      .post<string>(
        `${environment.apiPath}/userBusiness/${payload.userId}/${payload.businessId}`,{})
        .pipe(
          map(item => item["data"])
        )
  }
  resendSentInvitation(payload: {userId: string, resellerId: string, businessId: string}): Observable<boolean> {
    return this.http
    .post(`${environment.apiPath}/users/invitation/resend`, { 
      userId: payload.userId, 
      resellerId: payload.resellerId, 
      businessId: payload.businessId
     }, {})
    .pipe(
      map(data => data as boolean)
    );
  }

  searchAllUsers(): Observable<UserBusinessModel[]> {
    return this.http
    .get<UserBusinessModel[]>(`${environment.apiPath}/userBusiness`)
    .pipe(
      // map((data: { data: UserModel[], total: number }) => data.data),
    );
  }

  searchUsersByReseller(payload: { page: number; size: number, resellerId: string; }): Observable<UserBusinessModel[]> {
    return this.http
      .get(`${environment.apiPath}/resellers/users?id=5dc19de1bade504654991601&page=${payload.page}&size=${payload.size}`)
      .pipe(
        map((data: { data: UserBusinessModel[], total: number }) => data.data),
        // map((data: UserModel[]) => data.map(user => ({ ...user, role: { ...user.role, name: changeUserRolesName(user.role.name) } }))),
      );
  }
}
